export const PACKAGE_CHART_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
  "#3B82F6",
  "#2563EB",
  "#1D4ED8",
];

export const formatPackageMoney = (
  amount,
  currency = "NGN",
  locale = "en-US",
) => {
  let formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);

  if (currency === "NGN") {
    formatted = formatted.replace(/^NGN/, "₦");
  } else if (currency === "USD") {
    formatted = formatted.replace(/^USD/, "$");
  }

  return formatted;
};

export const formatPackagePercentage = (value) => {
  const numericValue = Number(value) || 0;

  return `${numericValue.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}%`;
};

export const getPackageSummaryCards = (summaryMetrics) =>
  Object.values(summaryMetrics || {});

export const getPackageTrendData = (trendPayload) => {
  const labels = trendPayload?.labels || [];
  const datasets = trendPayload?.datasets || [];

  const revenueDataset = datasets.find((item) =>
    item?.label?.toLowerCase().includes("revenue"),
  );
  const bookingsDataset = datasets.find((item) =>
    item?.label?.toLowerCase().includes("booking"),
  );

  return labels.map((label, index) => ({
    month: label,
    revenue: revenueDataset?.data?.[index] || 0,
    bookings: bookingsDataset?.data?.[index] || 0,
  }));
};

export const getPackageCategoryBreakdown = (breakdownsData, categories = []) => {
  const categoriesById = new Map(
    (categories || []).map((category) => [category?._id, category]),
  );

  return (
    breakdownsData?.data?.categoryBreakdown?.map((item) => {
      const matchedCategory = categoriesById.get(item.category);

      return {
        ...item,
        name:
          matchedCategory?.title ||
          item.label ||
          item.category ||
          "Unknown category",
        description: matchedCategory?.description || "",
        value: item.revenue || item.amount || 0,
        sharePercentage: item.sharePercentage || 0,
      };
    }) || []
  );
};

export const getPackageUserTypeBreakdown = (breakdownsData) =>
  breakdownsData?.data?.revenueByUserType?.map((item) => ({
    ...item,
    name: item.userType,
    value: item.revenue,
  })) || [];
